import { render } from "./WhenEditor.vue?vue&type=template&id=5526cf96&ts=true"
import script from "./WhenEditor.vue?vue&type=script&lang=ts"
export * from "./WhenEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__